
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collaborations/[category]",
      function () {
        return require("private-next-pages/collaborations/[category]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collaborations/[category]"])
      });
    }
  